export function extractUrlFromStylesUrl(str: string): string | null {
  if (!str) {
    return null;
  }

  str = str.trim();

  const urlMatch = str.match(/^url\((['"]?)(.*?)\1\)$/i);
  if (urlMatch) {
    return urlMatch[2];
  }

  const plainMatch = str.match(/^(https?:\/\/[^\s]+)$/i);
  if (plainMatch) {
    return plainMatch[1];
  }

  return null;
}

export { getSafeLinkHref } from '@goldcast/utils/src/misc/url';

export function encodeFileName(fileName: string): string {
  return encodeURI(fileName).replaceAll('(', '%28').replaceAll(')', '%29');
}

export function getDecodedFileNameFromUrl(url: string): string {
  const font = encodeFileName(url);
  const fileName = font.split('/')?.at(-1)?.split('.')[0];
  return fullyDecodeURI(fileName || 'Custom Font');
}

function fullyDecodeURI(str: string): string {
  let prev;
  let current = str;
  do {
    prev = current;
    current = decodeURI(prev);
  } while (current !== prev);
  return current;
}

export function getEventIdFromUrl(): string | null {
  const urlParams = new URLSearchParams(window.location.search);
  const queryEventId = urlParams.get('eventID');
  if (queryEventId) {
    return queryEventId;
  }

  const pathname = window.location.pathname;

  const splashMatch = pathname.match(/\/splash\/([a-f0-9-]+)/i);
  if (splashMatch) {
    return splashMatch[1];
  }

  const eventMatch = pathname.match(/\/e\/([a-f0-9-]+)/i);
  if (eventMatch) {
    return eventMatch[1];
  }

  return null;
}

/**
 * The combined user API is only called BEFORE event entry — on the auth pages
 * (including the magic-link page) and the splash page. After entry, the app uses
 * the uuid-cached API directly.
 *   auth pages:  /auth, /auth/link/:email/:secretCode, /auth/embedded, ...
 *   splash page: /splash/:eventID
 */
export function isPreEventEntryPage(): boolean {
  const pathname = window.location.pathname;
  return /^\/auth(\/|$)/i.test(pathname) || /\/splash\//i.test(pathname);
}

export function isInsideEventPage(): boolean {
  return /^\/e\//i.test(window.location.pathname);
}
